export const encodeProductPath = (path: string): string => {
  return encodeURIComponent(path);
};

export const decodeProductPath = (encodedPath: string): string => {
  return decodeURIComponent(encodedPath);
};
